<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <span style="margin: 0 0 0 8px; text-transform: none; color: white">SafeNote</span>
        <img src="/img/brand/safenote-silver.png" alt="logo">
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand">
          <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/">
            <span style="margin: 0 0 0 8px; text-transform: none; color: black">SafeNote</span>
            <img src="/img/brand/safenote-primary.png">
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu" ref="closeButton"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">

        <router-link to="/" class="nav-link" @click.native="callClose">
          <span class="nav-item" >
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">یادداشت امن</span>
          </span>
        </router-link>

        <router-link to="/private-message" class="nav-link" @click.native="callClose">
          <span class="nav-item" >
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">پیام خصوصی</span>
          </span>
        </router-link>

        <router-link to="/anonymous-message" class="nav-link" @click.native="callClose">
          <span class="nav-item">
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">پیام ناشناس</span>
          </span>
        </router-link>


        <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl" v-if="false">
          <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">کامپوننتها</span>
          </a>
          <div class="dropdown-menu-inner">
            <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/"
               class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                <i class="ni ni-spaceship"></i>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-primary mb-md-1">Getting started</h6>
                <p class="description d-none d-md-inline-block mb-0">Get started with Bootstrap, the
                  world's most popular framework for building responsive sites.</p>
              </div>
            </a>
            <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/"
               class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                <i class="ni ni-ui-04"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-warning mb-md-1">Components</h5>
                <p class="description d-none d-md-inline-block mb-0">Learn how to use Argon
                  compiling Scss, change brand colors and more.</p>
              </div>
            </a>
          </div>
        </base-dropdown>

        <base-dropdown tag="li" class="nav-item" v-if="false">
          <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">مثالها</span>
          </a>
          <router-link to="/landing" class="dropdown-item">Landing</router-link>
          <router-link to="/profile" class="dropdown-item">Profile</router-link>
          <router-link to="/login" class="dropdown-item">Login</router-link>
          <router-link to="/register" class="dropdown-item">Register</router-link>
        </base-dropdown>

        <router-link to="/about" class="nav-link" @click.native="callClose">
          <span class="nav-item">
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">درباره ما</span>
          </span>
        </router-link>

      </ul>
    </base-nav>
  </header>
</template>

<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  methods: {
    callClose() {
      this.$refs.closeButton.handleClick(null);
    }
  }
};
</script>

<style scoped>
</style>
